export { default } from "./Cover";
